// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Campaign } from './campaign';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CampaignAction extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
    return this.date ? this.date.toLocaleDateString() : '';
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  campaignId!: number;
  created!: Date;
  createdBy?: string;
  date!: Date;
  deleted?: Date;
  deletedBy?: string;
  name?: string;
  campaign!: Campaign;
}

